/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-02-05 14:41:33
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-08-03 14:23:54
 * @FilePath: \crm-product\src\views\dms\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
  {
    name: 'contract',
    path: '/contract/manage',
    component: () => import('../views/contract/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'bill-check',
    path: '/bill/bill-check',
    component: () => import('../views/bill/bill-check'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'channel-cost-config',
    path: '/channel-cost/config',
    component: () => import('../views/rebate/channel-cost-config/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'channel-cost-list',
    path: '/channel-cost/list',
    component: () => import('../views/rebate/channel-cost-list/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '经销商渠道费用池',
    path: '/channel-cost/channel-cost-customer',
    component: () => import('../views/rebate/channel-cost-customer/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '经销商渠道费用奖励池',
    path: '/channel-cost/reward-channel-cost-customer',
    component: () => import('../views/rebate/reward-channel-cost-customer/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'channel-cost-apply',
    path: '/channel-cost/apply',
    component: () => import('../views/rebate/channel-cost-apply/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'capital-pool-typeB',
    path: '/capital-pool/typeB',
    component: () => import('../views/capital-pool/type-b/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'B类资金池明细',
    path: '/capital-pool/typeB/detail',
    component: () => import('../views/capital-pool/type-b-detail/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'capital-pool-cash',
    path: '/capital-pool/cash',
    component: () => import('../views/capital-pool/cash/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '现金流资金池明细',
    path: '/capital-pool/cash/detail',
    component: () => import('../views/capital-pool/cash-detail/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'goods-replenish',
    path: '/capital-pool/goods-replenish',
    component: () => import('../views/capital-pool/goods-replenish/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '货补池明细',
    path: '/capital-pool/goods-replenish/detail',
    component: () => import('../views/capital-pool/goods-replenish-detail/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '货补池明细',
    path: '/capital-pool/goods-replenish/detail',
    component: () => import('../views/capital-pool/goods-replenish-detail/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '渠道费用划转货补池',
    path: '/chanelPool/channelPoolMain',
    component: () => import('../views/channelPool/channelPoolMain/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '渠道费用划转货补池明细',
    path: '/chanelPool/channelPoolDetails',
    component: () => import('../views/channelPool/channelPoolDetails/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '年度模糊奖励划转货补池',
    path: '/chanelPoolVague/channelPoolMain',
    component: () => import('../views/channelPoolVague/channelPoolMain/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '年度模糊奖励划转货补池明细',
    path: '/chanelPoolVague/channelPoolDetails',
    component: () => import('../views/channelPoolVague/channelPoolDetails/index'),
    meta: {
      keepAlive: false,
    },
  },

  // 划转
  {
    name: '划转经销商折扣池_终端红包池配置',
    path: '/transferDiscountPoolAndRedPool/setting',
    component: () => import('../views/transferDiscountPoolAndRedPool/setting/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '费用预算划转折扣池/红包池',
    path: '/transferDiscountPoolAndRedPool/transfer',
    component: () => import('../views/transferDiscountPoolAndRedPool/transfer/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '费用预算划转折扣池/红包池明细',
    path: '/transferDiscountPoolAndRedPool/transferDetail',
    component: () => import('../views/transferDiscountPoolAndRedPool/transferDetail/table'),
    meta: {
      keepAlive: false,
    },
  },

  {
    name: 'need-goods',
    path: '/order/need-goods/list',
    component: () => import('../views/order/need-goods/table/table'),
    meta: {
      keepAlive: false,
    },
  },

  {
    name: 'need_goods_simple',
    path: '/order/need-goods/need_goods_simple',
    component: () => import('../views/order/need_goods_simple/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'need_goods_config',
    path: '/order/need-goods/need_goods_config',
    component: () => import('../views/order/need_goods_config'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'need_goods_detail',
    path: '/order/need_goods_detail',
    component: () => import('../views/order/need_goods_detail/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'low-price',
    path: '/other/low-price/list',
    component: () => import('../views/other/low-price/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'counterfeiting',
    path: '/other/counterfeiting/list',
    component: () => import('../views/other/counterfeiting/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'back',
    path: '/order/back/list',
    component: () => import('../views/order/back/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'anxious',
    path: '/order/anxious/list',
    component: () => import('../views/order/anxious/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'urgently_needed_detail',
    path: '/order/urgently_needed_detail',
    component: () => import('../views/order/urgently_needed_detail'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'send',
    path: '/order/send/list',
    component: () => import('../views/order/send/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'invoice',
    path: '/order/invoice/list',
    component: () => import('../views/order/invoice/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'quota_management',
    path: '/order/quota_management',
    component: () => import('../views/order/quota_management'),
    meta: {
      keepAlive: true,
      title: '配额管理',
    },
  },
  {
    name: 'dealer_quota_management',
    path: '/order/dealer_quota_management',
    component: () => import('../views/order/dealer_quota_management'),
    meta: {
      keepAlive: true,
      title: '经销商配额管理',
    },
  },
  {
    name: 'dealer_quota_report',
    path: '/order/dealer_quota_report',
    component: () => import('../views/order/dealer_quota_report'),
    meta: {
      keepAlive: true,
      title: '经销商配额报表',
    },
  },
  // 要货计划明细
  {
    name: 'demand_plan_detail',
    path: '/order/demand_plan_detail/list',
    component: () => import('../views/order/demand_plan_detail/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'significance',
    path: '/order/significance/list',
    component: () => import('../views/order/significance/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'remittance',
    path: '/bill/remittance/list',
    component: () => import('../views/bill/remittance/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'reconciliation',
    path: '/bill/reconciliation/list',
    component: () => import('../views/bill/reconciliation/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'capital-account',
    path: '/bill/capital-account/list',
    component: () => import('../views/bill/capital-account/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'anxious_detail_report',
    path: '/order/anxious_detail_report',
    component: () => import('../views/order/anxious_detail_report/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 货权转移
  {
    name: 'cargo',
    path: '/InventoryManagement/cargo',
    component: () => import('../views/InventoryManagement/cargo/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 库存汇总表
  {
    name: 'inventoryCollect',
    path: '/InventoryManagement/inventoryCollect',
    component: () => import('../views/InventoryManagement/inventoryCollect/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 进销存明细表
  {
    name: 'saleInventory',
    path: '/InventoryManagement/saleInventory',
    component: () => import('../views/InventoryManagement/saleInventory/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 盘点
  {
    name: 'inventory',
    path: '/InventoryManagement/Inventory',
    component: () => import('../views/InventoryManagement/Inventory/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 盘点明细表
  {
    name: 'InventoryDetail',
    path: '/InventoryManagement/InventoryDetail',
    component: () => import('../views/InventoryManagement/InventoryDetail/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 分利协议管理-配置列表
  {
    name: 'configuration',
    path: '/sharing_agreement/configuration_list',
    component: () => import('../views/sharing_agreement/configuration_list/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 分利协议管理-现金发放报表
  {
    name: 'cash_distribution',
    path: '/sharing_agreement/cash_distribution',
    component: () => import('../views/sharing_agreement/cash_distribution/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 分利协议管理-人员新增终端网点报表
  {
    name: 'terminal_report',
    path: '/sharing_agreement/terminal_report',
    component: () => import('../views/sharing_agreement/terminal_report/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 再来一瓶
  {
    name: 'another_bottle',
    path: '/anotherBottle/list',
    component: () => import('../views/anotherBottle/list/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 终端标签
  {
    name: 'terminal_label',
    path: '/terminal_label',
    component: () => import('../views/terminal_label/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 分利协议管理-分利协议
  {
    name: 'sharing',
    path: '/sharing_agreement/sharing_list',
    component: () => import('../views/sharing_agreement/sharing_list/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 终端入库详情
  {
    name: 'terminal_scan_in_record',
    path: '/terInInfo',
    component: () => import('../views/terInInfo/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 分利协议管理-分利协议
  {
    name: 'reward',
    path: '/sharing_agreement/reward_list',
    component: () => import('../views/sharing_agreement/reward_list/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 分利协议管理-陈列审核
  {
    name: 'display_ad',
    path: '/sharing_agreement/display_auditing',
    component: () => import('../views/sharing_agreement/display_auditing/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 产品分值规则
  {
    name: 'product_score_rules',
    path: '/terminalFxh/product_score_rules',
    component: () => import('../views/terminal/product-score-rules/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'rading_engine',
    path: '/terminalFxh/rading_engine',
    component: () => import('../views/terminal/rading-engine/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 秩序管理规则
  {
    name: 'order_management_rules',
    path: '/terminalFxh/order_management_rules',
    component: () => import('../views/terminal/order-management-rules/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 凤香定级因素
  {
    name: 'grading_factors',
    path: '/terminalFxh/grading_factors',
    component: () => import('../views/terminal/grading-factors/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 终端档级调整管理
  {
    name: 'level_adjustment_management',
    path: '/terminalFxh/level_adjustment_management',
    component: () => import('../views/terminal/level-adjustment-management/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 结算周期配置
  {
    name: 'settlement_cycle_configuration',
    path: '/terminalFxh/settlement_cycle_configuration',
    component: () => import('../views/terminal/settlement-cycle-configuration/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 凤香荟季度分值报表
  {
    name: 'quarterly_score_report',
    path: '/terminalFxh/quarterly_score_report',
    component: () => import('../views/terminal/quarterly-score-report/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 凤香荟季度分值报表
  {
    name: 'history_quarterly_score_report',
    path: '/terminalFxh/history_quarterly_score_report',
    component: () => import('../views/terminal/quarterly-score-report-history/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 本季度权益数据报表
  {
    name: 'quarter_data',
    path: '/terminalFxh/quarter_data',
    component: () => import('../views/terminal/quarter-data/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 红西凤/综合终端分值报表
  {
    name: 'terminal_score_report',
    path: '/terminalFxh/terminal_score_report',
    component: () => import('../views/terminal/terminal_score_report/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 历史权益数据报表
  {
    name: 'history_data',
    path: '/terminalFxh/history_data',
    component: () => import('../views/terminal/history-data/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 凤香荟公告管理
  {
    name: 'announcement_management',
    path: '/terminalFxh/announcement_management',
    component: () => import('../views/terminal/announcement-management/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 品推兑付权益报表
  {
    name: 'product_promotion_report',
    path: '/terminalFxh/product_promotion_report',
    component: () => import('../views/terminal/product-promotion-report/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 赠酒兑付报表
  {
    name: 'gift_wine_report',
    path: '/terminalFxh/gift_wine_report',
    component: () => import('../views/terminal/gift-wine-report/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 权益兑付记录表
  {
    name: 'equity_redemption_record',
    path: '/terminalFxh/equity_redemption_record',
    component: () => import('../views/terminal/equity_redemption_record/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 提额活动1
  {
    name: 'increase_amount_activity',
    path: '/terminalFxh/increase_amount_activity',
    component: () => import('../views/terminal/increase_amount_activity/table/index'),
    meta: {
      keepAlive: false,
    },
  },

  // 网点建设
  {
    name: 'network_construction',
    path: '/terminalFxh/network_construction',
    component: () => import('../views/terminal/network_construction/table/index'),
    meta: {
      keepAlive: false,
      title: '凤香荟网点建设',
    },
  },
  {
    name: 'filiale_scan_in',
    path: '/terminalFxh/filiale_scan_in',
    component: () => import('../views/terminal/filiale_scan_in/table/index'),
    meta: {
      keepAlive: false,
      title: '分公司终端扫码进货',
    },
  },
  {
    name: 'maintenance_construction_goals',
    path: '/terminalFxh/maintenance_construction_goals',
    component: () => import('../views/terminal/maintenance_construction_goals/table/index'),
    meta: {
      keepAlive: false,
      title: '网点建设目标维护',
    },
  },

  {
    name: 'terminal_fee',
    path: '/terminal_order/terminal_fee',
    component: () => import('../views/terminal_order/terminal_fee'),
    meta: { title: '终端费用' },
  },
  {
    name: 'terminal_market_activities',
    path: '/terminal_order/terminal_market_activities',
    component: () => import('../views/terminal_order/terminal_market_activities'),
    meta: { title: '终端市场活动' },
  },
  {
    name: 'terminal_balance',
    path: '/terminal_order/terminal_balance',
    component: () => import('../views/terminal_order/terminal_balance'),
    meta: { title: '终端余额' },
  },
  {
    name: 'price_maintenance',
    path: '/terminal_order/price_maintenance',
    component: () => import('../views/terminal_order/price_maintenance'),
    meta: { title: '商品价格维护' },
  },
  {
    name: 'terminal_order',
    path: '/terminal_order/terminal_order',
    component: () => import('../views/terminal_order/terminal_order'),
    meta: { title: '终端订单' },
  },
  {
    name: 'terminal_stock',
    path: '/terminal_order/terminal_stock',
    component: () => import('../views/terminal_order/terminalStock/table/index'),
    meta: { title: '终端库存' },
  },
  {
    name: 'terminal_shipping_order',
    path: '/terminal_order/terminal_shipping_order',
    component: () => import('../views/terminal_order/terminal_shipping_order/index'),
    meta: { title: '终端发货单' },
  },
  {
    name: 'terminal_invoice',
    path: '/terminal_order/terminal_invoice',
    component: () => import('../views/terminal_order/terminal_invoice/index'),
    meta: { title: '系统发票清单' },
  },
  // 终端下单-合同管理
  {
    name: 'contract_management',
    path: '/terminal_order/contract_management',
    component: () => import('../views/terminalOrdering/contractManagement/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 个人信息档案
  {
    name: 'personalInfo',
    path: '/personaAndCompany/personalInfo',
    component: () => import('../views/personaAndCompany/personalInfo/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 企业信息档案
  {
    name: 'companyInfo',
    path: '/personaAndCompany/companyInfo',
    component: () => import('../views/personaAndCompany/companyInfo/table/index'),
    meta: {
      keepAlive: false,
    },
  },
  // 已清理终端
  {
    name: 'terminal_cleared',
    path: '/terminal_order/terminal_cleared',
    component: () => import('../views/terminal_order/terminal_cleared/index'),
    meta: { title: '已清理终端' },
  },
  // 沉寂终端
  {
    name: 'silent_terminal',
    path: '/terminal_order/silent_terminal',
    component: () => import('../views/terminal_order/silent_terminal/index'),
    meta: { title: '沉寂终端' },
  },
  // 无营业执照终端
  {
    name: 'terminal_without_business_license',
    path: '/terminal_order/terminal_without_business_license',
    component: () => import('../views/terminal_order/terminal_without_business_license/index'),
    meta: { title: '无营业执照终端' },
  },
];
